import React  from 'react';
import Rebus from '../../components/rebus';

import './style.css';  //  !!!

import platezh from './images/platezh.jpg';
import banknota from './images/banknota.jpg';
import moneta from './images/moneta.jpg';
import perevod from './images/perevod.jpg';
import veksel from './images/veksel.jpg';
// import dohod from './images/dohod.jpg';

const imgs = {
  platezh,
  banknota,
  moneta,
  perevod,
  veksel,
}

const PageWithRebus = ({ onNextLevel, messNext, answer, setAnswer, props } ) => {

const img = imgs[props];

  return ( 
		<Rebus onNextLevel={onNextLevel} messNext={messNext} answer={answer} setAnswer={setAnswer} img={img} />
    );
}   

export default PageWithRebus;
